<!--
 * @Descripttion: 带form表单的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 21:00:27
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-10-12 15:43:17
-->
<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:size="800"
		:before-close="handleClose"
		:wrapperClosable="wrapperClosable"
		custom-class="drawer-template"
	>
		<Tip> 同个样品订单可以录入多个物流信息，将在样品订单下生成多个包裹 </Tip>
		<div class="mt-24">
			<div class="item flex-row flex-align-end font-h4-regular mb-24" v-for="(item, index) in packageList" :key="index">
				<div class="flex-row flex-align-center radius-4 left flex-1">
					<span class="yx-color-text-primary" style="width: 46px">包裹{{ index + 1 }}</span>
					<div class="flex-row flex-align-center ml-24">
						<p class="yx-color-text-regular mr-8 nowarp">物流单号</p>
						<el-input
							placeholder="请输入"
							@input="inputRule(item)"
							v-model.trim="item.sn"
							@keyup.enter.native="handleEnterEvent(item)"
							@blur="handleEnterEvent(item)"
						/>
					</div>
					<div class="flex-row flex-align-center">
						<span class="ml-18 yx-color-text-regular mr-8">物流公司</span>
						<el-select v-model="item.company" filterable @change="getCompanyFun($event, item)" placeholder="请选择">
							<el-option :label="item.express_name" :value="item.express_name" v-for="(item, index) in companyList" :key="index"></el-option>
						</el-select>
					</div>
				</div>
				<div style="width: 32px" class="flex-row flex-just-end">
					<i class="el-icon-delete yx-color-text-secondary cursor-pointer hover" @click="delItem(index)" v-if="!item.default"></i>
				</div>
			</div>
		</div>
		<div class="mb-24">
			<el-button @click="addPageList" type="primary" plain>新增包裹</el-button>
		</div>
		<div class="drawer-footer yx-background-white">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="confirm" :loading="loading" :disabled="!!isDisabled">确认</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { expressList } from '@/api/cooperationProgress';
import { orderBatchDeliver, getDeliveryInfo } from '@/api/sampleOrder';
export default {
	props: {},
	components: {},
	data() {
		return {
			title: '样品发货', // 弹窗标题
			visible: false, // 弹窗显隐
			companyList: [],
			packageList: [{ company: '', code: '', sn: '', default: true }],
			loading: false, // 按钮loading状态
			sample_sn: '',
			cooperate_id: '',
		};
	},
	computed: {
		isDisabled({ packageList }) {
			const codeCheck = packageList.filter(item => !item.code).length;
			const snCheck = packageList.filter(item => !item.sn).length;
			return codeCheck || snCheck;
		},
	},
	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show({ cooperate_id, sample_sn }) {
			this.sample_sn = sample_sn;
			this.cooperate_id = cooperate_id;
			this.visible = true;
			this.getCompany();
		},
		async getCompany() {
			const { code, data } = await expressList({});
			if (code !== 0) return;
			this.companyList = data;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.sample_sn = '';
			this.cooperate_id = '';
			this.loading = false;
			this.packageList = [{ company: '', code: '', sn: '', default: true }];
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		async confirm() {
			// 按钮loading开启
			this.loading = true;
			const { cooperate_id, sample_sn, packageList: delivery_list } = this;
			let params = {
				cooperate_id,
				sample_sn,
				delivery_list,
			};
			try {
				await orderBatchDeliver(params);
				// 刷新列表（外部重新获取数据）
				this.$message.success('操作成功！');
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		},
		addPageList() {
			const defaultObj = { company: '', code: '', sn: '', default: false };
			this.packageList.push(defaultObj);
		},
		delItem(index) {
			this.packageList.splice(index, 1);
		},
		inputRule(item) {
			item['sn'] = item['sn'].replace(/[\W]/g, '');
		},
		async handleEnterEvent(item) {
			if (!item['sn']) return;
			try {
				let data = await getDeliveryInfo({
					deliveryCode: item['sn'],
				});
				item.company = data?.deliveryName || '';
				item.code = data?.expressCode || '';
			} catch (e) {}
		},

		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		getCompanyFun(e, item) {
			this.companyList.forEach(v => {
				if (v.express_name == e) {
					item.code = v.express_code;
				}
			});
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.item {
	.left {
		padding: 16px 20px;
		background-color: #f7f8fa;
		::v-deep .el-input--small {
			width: 220px;
		}
	}
}
</style>
